import styled from "styled-components";

export const ButtonContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;
  cursor: pointer;
  /* background-color: ${({ theme }) => theme.colors.darkGreen}; */

  &:hover {
    background-color: ${({ theme }) => theme.colors.extraLightGray};
  }
`;
